import { Trans } from 'app/core/internationalization';
const Routing = () => <Trans i18nKey="alerting.routing.routing">Routing</Trans>;

export { Routing };
